import { FieldHasValue } from 'helpers/Validation';

export const AsLeftResultP723Formula = (formData) => {
    if (FieldHasValue(formData.F461AltPushbuttonWasActivatedInField) && FieldHasValue(formData.F378AltHmistatus1)) {
        if ((formData.F461AltPushbuttonWasActivatedInField === 'YES') && (formData.F378AltHmistatus1 === 'ALARM')) {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
